import { Modal } from 'antd'
import React from 'react'
import { isDesktop, isMobile, isTablet } from 'react-device-detect'
import { IconContext } from 'react-icons'
import { FiCheckCircle } from 'react-icons/fi'
import Button from '../Button'

interface InvestedEmailModalProps {
  isVisible: boolean
  onStartBeginning: () => void
  onReinvest: () => void
  onCancel: () => void
}

const InvestedEmailModal = ({ isVisible, onStartBeginning, onReinvest, onCancel }: InvestedEmailModalProps) => {
  return (
    <>
      <Modal
        width={`${(isMobile || isTablet) && !isDesktop ? '90vw' : '50vw'}`}
        open={isVisible}
        centered
        footer={null}
        closable={false}
      >
        <div className="flex flex-col items-center py-4 md:py-4">
          <div className="text-5xl">
            <IconContext.Provider value={{ color: 'green' }}>
              <FiCheckCircle />
            </IconContext.Provider>
          </div>
          <div className="mt-4 text-center text-3xl font-semibold md:mt-4 md:text-4xl">You have already invested</div>
          <div className="my-4 text-xl md:my-0 md:px-6 md:text-2xl">
            <div className="my-5 text-center">
              If you would like to continue filing out the form, click "Start from beginning" and use a different email.
            </div>
            <div className="my-5 text-center">If you would like to continue with reinvesting, click Re-Invest.</div>
          </div>

          <div className="flex w-full justify-center gap-8 px-10 md:p-10 md:px-0">
            <div className="flex w-full flex-col items-center">
              <Button
                btnName={'Start from beginning'}
                type="secondary"
                btnType={'submit'}
                onClickHandler={onStartBeginning}
              />
            </div>
            <div className="flex w-full flex-col items-center">
              <Button btnName={'Re-invest'} btnType={'submit'} onClickHandler={onReinvest} />
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default InvestedEmailModal
